import { ActionTypes } from "../../../reducer/propertyReducer";
import Select from "../../../../shared/select/Select";
import ButtonGroup from "../../../../shared/button-group/ButtonGroup";
import { buildingTypeOptions, sortByOptions, specialtyFeatureOptions, zoningOptions } from "../../utils/dropdown-options";
import { iBuildingsForm } from "./interfaces";
import Radius, { RadiusHandle } from "../radius/Radius";
import { ForwardRefRenderFunction, forwardRef } from "react";

const BuildingsForm: ForwardRefRenderFunction<RadiusHandle, iBuildingsForm> = ({
  view,
  radiusSketchLayer,
  state,
  dispatch, 
  flexDirection, 
  inputStyle,
  stateOptions,
  regionOptions,
  bCityOpts,
  bCountyOpts,
  filterByMapExtentHandler,
  filterByMapExtentValue,
  setRadiusFilterGeometry
}, ref) => {
  return (
    <>
      <div className="flex-form">
        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <label htmlFor="bKeywordSearch">Keyword Search</label>
            <input
              placeholder='Search..'
              type="text"
              name="keyword search"
              value={state.bKeywordSearch}
              onChange={(evt) => dispatch({ type: ActionTypes.SetBKeywordSearch, payload: evt.target.value })}
            />
          </div>
          <div className="input-container" style={inputStyle}>
            <label htmlFor="bAvailableAcres">Available Acres</label>
            <div id="acres-input" className="flex-row align-items-center">
              <input
                type="number"
                name="bAvailableAcresMin"
                placeholder='0'
                value={state.bAvailableAcresMin}
                min={0}
                onChange={(evt) => dispatch({ type: ActionTypes.SetBAvailableAcresMin, payload: evt })}
              />
              <span>-</span>
              <input
                type="number"
                name="bAvailableAcresMax"
                placeholder="Enter Max"
                value={state.bAvailableAcresMax}
                onChange={(evt) => dispatch({ type: ActionTypes.SetBAvailableAcresMax, payload: evt })}
              />

            </div>
          </div>
        </div>
        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'Building Type'}
              labelPosition='top'
              multiSelect={true}
              selectedItems={Array.from(state.bBuildingTypes)}
              onClear={() => dispatch({ type: ActionTypes.SetBBuildingTypes, payload: new Set() })}>
              <div>
                {buildingTypeOptions?.map((option: any) =>
                  <div key={option} className="filter-option">
                    <input
                      type="checkbox"
                      id={`bBuildingTypes-${option}`}
                      value={option}
                      checked={state.bBuildingTypes.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetBBuildingTypes, payload: evt })} />
                    <label htmlFor={`bBuildingTypes-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>
          <div className="input-container" style={inputStyle}>
            <label htmlFor="bAvailableSqFt">Available Square Feet</label>
            <div id="acres-input" className="flex-row align-items-center">
              <input
                type="number"
                name="bAvailableSqFtMin"
                placeholder='0'
                value={state.bAvailableSqFtMin}
                min={0}
                onChange={(evt) => dispatch({ type: ActionTypes.SetBAvailableSqFtMin, payload: evt })}
              />
              <span>-</span>
              <input
                type="number"
                name="bAvailableSqFtMax"
                placeholder="Enter Max"
                value={state.bAvailableSqFtMax}
                onChange={(evt) => dispatch({ type: ActionTypes.SetBAvailableSqFtMax, payload: evt })}
              />

            </div>
          </div>
        </div>

        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'Specialty Features'}
              labelPosition='top'
              multiSelect={true}
              selectedItems={Array.from(state.bSpecialtyFeatures)}
              onClear={() => dispatch({ type: ActionTypes.SetBSpecialtyFeatures, payload: new Set() })}>
              <div >
                {specialtyFeatureOptions?.map((option: any) =>
                  <div key={option} className="filter-option">
                    <input
                      type="checkbox"
                      id={`bSpecialtyFeatures-${option}`}
                      value={option}
                      checked={state.bSpecialtyFeatures.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetBSpecialtyFeatures, payload: evt })} />
                    <label htmlFor={`bSpecialtyFeatures-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>
          <div className="input-container" style={inputStyle}>
            <ButtonGroup
              groupLabel='Rail Served'
              buttons={['All', 'Yes', 'No', 'Maybe']}
              onChange={(evt) => dispatch({ type: ActionTypes.SetBRailServed, payload: evt.currentTarget.name })}
              value={state.bRailServed}
            />
          </div>
        </div>

        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'Zoning Descriptions'}
              labelPosition='top'
              multiSelect={true}
              selectedItems={Array.from(state.bZoning)}
              onClear={() => dispatch({ type: ActionTypes.SetBZoning, payload: new Set() })}>
              <div >
                {zoningOptions?.map((option: any) =>
                  <div key={option} className="filter-option">
                    <input
                      type="checkbox"
                      id={`bZoning-${option}`}
                      value={option}
                      checked={state.bZoning.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetBZoning, payload: evt })} />
                    <label htmlFor={`bZoning-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>

          <div className="input-container" style={inputStyle}>
            <ButtonGroup
              groupLabel='Building Tenancy'
              buttons={['All', 'Single', 'Multi']}
              onChange={(evt) => dispatch({ type: ActionTypes.SetBMultiTenant, payload: evt.currentTarget.name })}
              value={state.bMultiTenant}
            />
          </div>
        </div>
        {/* <div className={`${flexDirection} gap-12`}>
								  <div className="input-container" style={inputStyle}>
									<Select
									  label={'Review Status'}
									  labelPosition='top'
									  multiSelect={true}
									  selectedItems={Array.from(state.bReviewStatus)}
									  onClear={() => dispatch({ type: ActionTypes.SetBReviewStatus, payload: new Set() })}>
									  <div >
										{reviewStatusOptions?.map((option: any) =>
										  <div key={option} className="filter-option">
											<input
											  type="checkbox"
											  id={`bReviewStatus-${option}`}
											  value={option}
											  checked={state.bReviewStatus.has(option)}
											  onChange={(evt) => dispatch({ type: ActionTypes.SetBReviewStatus, payload: evt })} />
											<label htmlFor={`bReviewStatus-${option}`}>{option}</label>
										  </div>
										)}
									  </div>
									</Select>
								  </div>

								</div> */}
        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'State(s)'}
              labelPosition='top'
              multiSelect={true}
              disabled={state.bRegions.size > 0}
              disabledText={'Clear Region to select a State'}
              selectedItems={Array.from(state.bStates)}
              onClear={() => dispatch({ type: ActionTypes.SetBStates, payload: new Set() })}>
              <div className='state-select'>
                {stateOptions?.map((option: any) =>
                  <div key={option.label} className="state-option">
                    <input
                      type="checkbox"
                      id={`bStates-${option.value}`}
                      value={option.value}
                      checked={state.bStates.has(option.value)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetBStates, payload: evt })} />
                    <label htmlFor={`bStates-${option.value}`}>{option.label}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'Region'}
              labelPosition='top'
              multiSelect={true}
              disabled={state.bStates.size > 0}
              disabledText={'Clear State to select a Region'}
              selectedItems={Array.from(state.bRegions)}
              onClear={() => dispatch({ type: ActionTypes.SetBRegions, payload: new Set() })}>
              <div>
                {Array.from(regionOptions).map((option: any) =>
                  <div key={option} className="filter-option">
                    <input
                      type="checkbox"
                      id={`bRegions-${option}`}
                      value={option}
                      checked={state.bRegions.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetBRegions, payload: evt })} />
                    <label htmlFor={`bRegions-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>
        </div>
        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'City'}
              labelPosition='top'
              multiSelect={true}
              disabled={(state.bStates.size === 0 && state.bRegions.size === 0) || bCityOpts.length === 0}
              disabledText={(state.bStates.size === 0 && state.bRegions.size === 0) ? 'Select a state or region' : 'No cities found'}
              selectedItems={Array.from(state.bCities)}
              onClear={() => dispatch({ type: ActionTypes.SetBCities, payload: new Set() })}>
              <div>
                {bCityOpts.map((option: any) =>
                  <div key={option} className="filter-option">
                    <input
                      type="checkbox"
                      id={`bCities-${option}`}
                      value={option}
                      checked={state.bCities.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetBCities, payload: evt })} />
                    <label htmlFor={`bCities-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'County'}
              labelPosition='top'
              multiSelect={true}
              disabled={(state.bStates.size === 0 && state.bRegions.size === 0) || bCountyOpts.length === 0}
              disabledText={(state.bStates.size === 0 && state.bRegions.size === 0) ? 'Select a state or region' : 'No counties found'}
              selectedItems={Array.from(state.bCounties)}
              onClear={() => dispatch({ type: ActionTypes.SetBCounties, payload: new Set() })}>
              <div>
                {bCountyOpts.map((option: any) =>
                  <div key={option} className="filter-option">
                    <input
                      type="checkbox"
                      id={`bCounties-${option}`}
                      value={option}
                      checked={state.bCounties.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetBCounties, payload: evt })} />
                    <label htmlFor={`bCounties-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>
        </div>

        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'Sort List Results By'}
              labelPosition='top'
              multiSelect={false}
              selectedItems={[state.bSortBy]}
            >
              {sortByOptions.map((option) =>
                <div onClick={() => dispatch({ type: ActionTypes.SetBSortBy, payload: option })} className="select-option" key={option}>{option}</div>
              )}
            </Select>
          </div>
          <div className="input-container" style={inputStyle}></div>
        </div>

        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <ButtonGroup
              groupLabel='Filter By Map Extent'
              buttons={['Yes', 'No']}
              onChange={(evt) => filterByMapExtentHandler(evt)}
              value={filterByMapExtentValue === true ? 'Yes' : 'No'}
            />
          </div>

          <div className="input-container" style={inputStyle}>
            <ButtonGroup
              groupLabel='For Sale or Lease'
              buttons={['All', 'Sale', 'Lease']}
              onChange={(evt) => dispatch({ type: ActionTypes.SetBSaleOrLease, payload: evt.currentTarget.name })}
              value={state.bSaleOrLease}
            />
          </div>
        </div>

        <div className='flex-row'>
          <div className="input-container" style={inputStyle}>
            <Radius
              ref={ref}
              mapView={view}
              sketchLayer={radiusSketchLayer}
              centerPoint={state.radiusCenterPoint}
              setRadiusGeometry={setRadiusFilterGeometry}
            />
          </div>
        </div>
      </div>
      <div className="filler"></div>
    </>
  );
}

export default forwardRef(BuildingsForm);